/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.educator-growth.analytics'},
});

const AnalyticsItem = () => (
  <RouteLinkItem
    route="midas/settings/educator-growth/analytics"
    title={messages.title}
  />
);

export default AnalyticsItem;
